<template>
  <v-dialog v-model="props.isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>

      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Assign Virtual Assistants</v-toolbar-title>
      </v-toolbar>

      <div class="">
        <v-container>
          <v-card-text class="col-md-6">
            <v-card-title>Filter Virtual Assistants</v-card-title>

            <div class="d-flex flex-row flex-wrap">
              <v-card-text class="col-6">
                <v-text-field v-model="state.filters.username" label="VA Name" dense hide-details outlined>
                </v-text-field>
              </v-card-text>

              <v-card-text class="col-6">
                <v-text-field v-model="state.filters.email" label="VA Email" dense hide-details outlined></v-text-field>
              </v-card-text>
            </div>

            <v-card-actions>
              <v-btn @click="applyFilters" color="primary">Update Table</v-btn>
              <v-btn @click="clearFilters">Reset</v-btn>
            </v-card-actions>

          </v-card-text>
          <!-- :page="state.page" :items-per-page="state.itemsPerPage" -->
          <v-data-table :headers="tableHeaders" :items="state.tableData" v-model="selection" :single-select="false"
            :customColumns="customColumns" :loading="state.isLoading" no-data-text="No Data" :calculate-widths="true">

            <template v-slot:item.username="{ item }">
              <div v-show="item.first_name">
                <v-avatar size="30px">
                  <img :src="resolveProfilePic(item)" alt="" loading="lazy" />
                </v-avatar>
                <span class="ml-2 text-capitalize ">{{ item.first_name }} {{ item.last_name }}</span>
              </div>
              <span v-show="!item.first_name">No VA</span>
            </template>

            <template v-slot:item.ssm_id="{ item }">
              <span>{{ item.ssm_id }}</span>
            </template>

            <template v-slot:item.email="{ item }">
              <span>{{ item.email }}</span>
            </template>

            <template v-slot:item.manageBtn="{ item, index }">
              <v-btn color="success" text @click="assignVaToClient(item, index)" :disabled="isDisable(item.id, 'assign')">
                ASSIGN</v-btn>
              <v-btn color="error" text @click="removeVaToClient(item)" :disabled="isDisable(item.id, 'revoke')">
                REVOKE</v-btn>
            </template>

          </v-data-table>
        </v-container>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import { onMounted, onUnmounted, onUpdated, reactive, ref } from "@vue/composition-api"
import { resolveProfilePic } from "@/helpers";
import axios from '@axios'

export default {
  props: ['isOpen', 'user', 'userID'],
  setup(props, { emit }) {
    const dialog = ref(false)
    const selection = ref([])
    const state = reactive({
      tableData: [],
      isLoading: false,
      isEditing: false,
      selected: [],
      isSubmitting: false,
      itemsPerPage: 20,
      totalItems: 0,
      page: 1,
      editTarget: {},
      filters: {
        username: "",
        email: "",
      },
    });

    onUpdated(async () => {
      selection.value = props.user
    })

    const tableHeaders = [
      { text: "Name", value: "username", sortable: false },
      { text: "SSM ID", value: "ssm_id", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "", value: "manageBtn", sortable: false },
    ];

    const customColumns = [
      { slotName: "manage-btn", itemValue: "manageBtn" },
    ];

    function applyFilters() {
      state.page = 1;
      fetchTableData();
    }

    function clearFilters() {
      state.page = 1;
      state.filters.username = "";
      state.filters.email = "";
      fetchTableData();
    }

    async function fetchTableData() {
      try {
        state.isLoading = true;
        const { data:virtual_assistant } = await axios.get("/user/virtual-assistants", {
          params:{ page: state.page, ...state.filters },
        });
        state.tableData = virtual_assistant.data.users;
        state.page = parseInt(virtual_assistant.data.page);
        state.itemsPerPage = virtual_assistant.data.itemsPerPage;
        state.totalItems = virtual_assistant.data.total;
      } catch (err) {
        this.$confirm("Failed");
      } finally {
        state.isLoading = false;
      }
    }


    const assignVaToClient = async (item, index) => {
      try {
        state.isLoading = true
        await axios.post(`/user/assign-va`, { client_id: props.userID, va_id: item.id})
        selection.value.push(item)
        state.isLoading = false
      } catch (err) {
        console.log(err)
        state.isLoading = false
        throw err
      }
    }

    const removeVaToClient = async (item) => {
      try {
        state.isLoading = true
        await axios.post(`/user/remove-va`, { client_id: props.userID, va_id: item.id })
        removeFromSelection(item.id)
        state.isLoading = false
      } catch (err) {
        console.log(err)
        throw err
      }
    }

    const isDisable = (id, type) => {
      if (type == 'assign') {
        let res = selection.value.find((item) => item.id == id)
        return res != undefined ? true : false
      }
      else {
        let res = selection.value.find((item) => item.id == id)
        return res == undefined ? true : false
      }
    }

    const removeFromSelection = (id) => {
      let index = selection.value.findIndex((item) => item.id == id)
      selection.value.splice(index, 1)
    }

    onMounted(async () => {
      console.log("onMounted :: ",props.userID)
      await fetchTableData()
    })

    onUnmounted(() => {
      console.log("onUnmounted :: ")
    })

    return {
      selection,
      dialog,
      props,
      removeFromSelection,
      resolveProfilePic,
      assignVaToClient,
      removeVaToClient,
      applyFilters,
      clearFilters,
      tableHeaders,
      customColumns,
      state,
      fetchTableData,
      isDisable
    }

  }
}
</script>